import { auth, fireStore } from '../../firebase'

export default ({
  state: {
    user: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    }
  },
  actions: {
    signUserIn ({ commit, dispatch }, payload) {
      commit('setLoading', true)
      commit('clearError')
      auth.signInWithEmailAndPassword(payload.email, payload.password)
        .then(
        user => {
          commit('setLoading', false)
          const newUser = {
            id: user.uid,
            email: user.email,
            name: user.displayName,
            company: '',
            fbKeys: {}
          }
          commit('setUser', newUser)
        }
        ).catch(
        error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        }
        )
    },
    autoSignIn ({ commit }, payload) {
      commit('setUser', {
        id: payload.uid,
        email: payload.email,
        name: payload.displayName,
        company: payload.company,
        unassigned: payload.unassigned,
        canSMS: payload.canSMS
      })
    },
    fetchUserData ({ commit, getters }) {
      commit('setLoading', true)
      fireStore.collection('Users').doc(getters.user.id).get()
        .then(doc => {
          let company = doc.data().Company
          let customers = doc.data().Customers
          let name = doc.data().Name
          let email = doc.data().Email
          let unassigned = doc.data().unassigned !== undefined ? doc.data().unassigned : true
          let canSMS = doc.data().canSMS !== undefined ? doc.data().canSMS : false
          const updateUser = {
            id: getters.user.id,
            email: email,
            name: name,
            company: company,
            customers: customers,
            unassigned: unassigned,
            canSMS: canSMS
          }
          commit('setLoading', false)
          commit('setUser', updateUser)
        })
        .catch(error => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    logout ({ commit }) {
      auth.signOut()
      commit('setUser', null)
    }
  },
  getters: {
    user (state) {
      return state.user
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/user/index.js